import { HTMLProps } from 'react';
import { useAsidePanelContext } from 'src/components/AsidePanel/contexts/AsidePanelContext';
import IconButton from 'src/components/IconButton/IconButton';
import ChevronLeftIcon from 'src/components/Icons/ChevronLeftIcon';
import { ChevronRightIcon } from 'src/components/Icons/ChevronRightIcon';
import { CloseSheetButton } from 'src/components/Sheet/CloseSheetButton';
import { PromptReplyPreviewBreadcrumbs } from './PromptReplyPreviewBreadcrumbs';
import { PromptReplyPreviewTimepoints } from './PromptReplyPreviewTimepoints';

type TNavigationButtonProps = { onClick: VoidFunction; disabled?: boolean; loading?: boolean };

export const PromptReplyPreviewNavbar = ({
  prevButton,
  nextButton,
}: {
  prevButton: TNavigationButtonProps;
  nextButton: TNavigationButtonProps;
}) => {
  const { closeAsidePanel } = useAsidePanelContext();

  return (
    <Wrapper>
      <Section>
        <BackButton {...prevButton} />
        <NextButton {...nextButton} />
      </Section>
      <PromptReplyPreviewBreadcrumbs />
      <Section>
        <PromptReplyPreviewTimepoints />
        <CloseSheetButton onClick={closeAsidePanel} />
      </Section>
    </Wrapper>
  );
};

const Wrapper = (props: HTMLProps<HTMLDivElement>) => (
  <div className="absolute top-6 left-0 right-0 z-20 px-6 bg-white-100 flex gap-x-2 items-center" {...props} />
);

const Section = (props: HTMLProps<HTMLDivElement>) => <div className="flex gap-x-2" {...props} />;

const BackButton = ({ onClick, disabled, loading }: TNavigationButtonProps) => (
  <IconButton loading={loading} disabled={disabled} onClick={onClick}>
    <ChevronLeftIcon />
  </IconButton>
);

const NextButton = ({ onClick, disabled, loading }: TNavigationButtonProps) => (
  <IconButton loading={loading} disabled={disabled} onClick={onClick}>
    <ChevronRightIcon />
  </IconButton>
);
